"use client";

import React from "react";
import StatsCard from "../../components/stats-card";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import styles from "./dispensary-menu.module.css";
import { useNavigate } from "react-router-dom";

const statsData = [
  { title: "Script", icon: "file-text" },
  { title: "Amend a Script", icon: "edit-3" },
  { title: "OTC Direct", icon: "shopping-bag" },
  { title: "To Follows", icon: "calendar-clock" },
  { title: "Medical History", icon: "stethoscope" },
  { title: "Label Function", icon: "printer" },
  { title: "Collections and Delivery", icon: "truck" },
  { title: "Clinic Script", icon: "hospital" },
  { title: "Reports", icon: "bar-chart-3" },
  { title: "Chronic", icon: "repeat" },
  { title: "Packaged Script", icon: "package" },
  { title: "Additional Information", icon: "info" },
];

export function DispensaryMenu() {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <Navbar onBack={() => {}} />
      <main className={styles.main}>
        <h1 className={styles.title}>Dispensary Menu</h1>
        <div className={styles.grid}>
          {statsData.map((stat, index) => (
            <StatsCard
              key={index}
              title={stat.title}
              icon={stat.icon}
              variant="square"
              onClick={
                stat.title === "Script"
                  ? () => navigate("/customer/dispensary/script")

                  : stat.title === "Amend a Script"
                    ? () => navigate("/customer/dispensary/ammend-script")
                    : stat.title === "Medical History"
                      ? () => navigate('/medical-history')
                      : stat.title === "Label Function"
                        ? () => navigate('/dispensary/label-configuration')
                        : stat.title === "To Follows"
                          ? () => navigate('/customer/dispensary/to-follows')
                          : stat.title === "Collections and Delivery"
                            ? () => navigate("/dispensary/collection-and-delivery")
                            : stat.title === "Additional Information"
                              ? () => navigate('/customer/dispensary/additional-information/generics-dictionary')
                              : stat.title === "Clinic Script"
                                ? () => navigate('/customer/dispensary/clinic-script')
                                : stat.title === "Chronic"
                                  ? () => navigate('/customer/dispensary/chronic-medication')
                                  : stat.title === "OTC Direct"
                                    ? () => navigate('/customer/dispensary/otcCustomer')
                                    : stat.title === "Packaged Script"
                                      ? () => navigate('/customer/dispensary/package-script')
                                      : stat.title === "Reports"
                                        ? () => navigate('/customer/dispensary/reports/script-statistics')
                                      : undefined

              }
            />
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default DispensaryMenu;
